import React from "react";
import styles from "./AccountType.module.css";
const AccountType = ({ account }) => {
  return (
    <>
      <div className={styles.userActions}>
        {/* <div className={styles.detailitem}> */}
        <div className={`${styles.label} ${styles.fuller} `}>
          <div className={styles.mkcol2}>
            <div>
              {account.type == "Wireguard" || account.type == "Ovpns" ? (
                <>
                  <i class="fa-solid fa-user"></i>
                  تک کاربره
                </>
              ) : (
                <>
                  <i class="fa-solid fa-user-group"></i>
                  دو کاربره
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountType;
